export { default } from 'pages/loyalty/loyalty-whopper-guarantee/loyalty-whopper-guarantee';
